module.exports = "/_next/static/images/production-2-min-a1f28d52b7000bf4c2396d29b13a3c50.png";